import { render, staticRenderFns } from "./WasteVehicleRegistration.vue?vue&type=template&id=1961e54c&"
import script from "./WasteVehicleRegistration.vue?vue&type=script&lang=js&"
export * from "./WasteVehicleRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports